import styled from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Color, SpacingSize } from "~/consts/style-mixins"

export const Title = styled(Typography)``

export const SubTitle = styled(Typography)`
  color: ${Color.Black};
  margin-top: ${SpacingSize.M}px;

  span {
    font-weight: bold;
    color: ${Color.Attention};
  }
`
